import { toast } from "react-toastify";
import { centralEquipmentsConstants } from "../../_constants";
import { centralGetInstrumentsService } from "../../_services";
import { alertActions } from "../alert.actions";
import { configActions } from "../config.actions";

function getCentralInstrumentsList(params) {
    return (dispatch,getState) => {
      dispatch(request());
      dispatch(configActions.showSpinningLoader());
      centralGetInstrumentsService(params).then(
          (res) => {
            dispatch(success(res));
            dispatch(configActions.hideSpinningLoader());
        // !!res?.description && toast.success(res.description)
  
          },
          (error) => {
        toast.error(error.description)
            dispatch(failure(error));
            dispatch(alertActions.error(error));
          }
        );
        dispatch(configActions.hideSpinningLoader());
    };
  
    function request() {
      return {
        type: centralEquipmentsConstants.FETCH_INSTRUMENTS_DATA_REQUESTING,
      };
    }
    function success(res) {
      return {
        type: centralEquipmentsConstants.CENTRAL_INSTRUMENTS_DATA_FETCHED,
        listData: res.data,
      };
    }
    function failure(error) {
      return { type: centralEquipmentsConstants.CENTRAL_INSTRUMENTS_DATA_FETCHED, error };
    }
  }

export const centralEquipmentsActions = {
    getCentralInstrumentsList,
};
